module.exports = __webpack_public_path__ + "img/W-6.3efd7a1e.jpg";